import React from "react";
import howWeHelpYou from "../assets/images/how-we-help-you.jpg";
import {BsCodeSlash} from "react-icons/bs";

const HowWeHelpYou = () => {
    return (
        <div className="how-we-help-you">
            <div className="container p-4">
                <div className="row">
                    <div className="col-md-6 d-flex justify-content-center align-items-center p-5">
                        <img src={howWeHelpYou} className="img-fluid" alt="Loading"/>
                    </div>
                    <div className="col-md-6">
                        <p className="tag pt-2">How We Help You</p>
                        <h2>An extended team that keeps you ahead of the curve.</h2>
                        <div className="how-we-help-you-right-content">
                            <p>
                                Our experienced team ensures your business isn't left behind in adopting
                                the latest technology. We act as your dedicated product partner — building,
                                launching, and scaling applications without delays or compromises on quality.
                            </p>
                        </div>
                        <div className="services-keys">
                            <div className="how-we-help-you-keys">
                                <BsCodeSlash style={{margin: '5px'}}/>
                                AI-powered automation
                            </div>
                            <div className="how-we-help-you-keys">
                                <BsCodeSlash style={{margin: '5px'}}/>
                                Enhanced customer experience
                            </div>
                            <div className="how-we-help-you-keys">
                                <BsCodeSlash style={{margin: '5px'}}/>
                                Improved profit margin
                            </div>
                            <div className="how-we-help-you-keys">
                                <BsCodeSlash style={{margin: '5px'}}/>
                                Customized solutions
                            </div>
                            <div className="how-we-help-you-keys">
                                <BsCodeSlash style={{margin: '5px'}}/>
                                Faster time to market
                            </div>
                            <div className="how-we-help-you-keys">
                                <BsCodeSlash style={{margin: '5px'}}/>
                                Scalability &amp; future-proofing
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default HowWeHelpYou;
